import "./styles.less";

import { Map, Marker, Popup, TileLayer, Circle } from "react-leaflet";
import React, { useState } from "react";

import Head from "next/head";
import L from "leaflet";
import Measure from "react-measure";
import OverPassLayer from "./OverPassLayer";

const MarkerIconPrimary = new L.Icon({
	iconUrl:
		"https://cdn2.infocasas.com.uy/web/5fdca925c0d57_infocdn__mapmarkerhouseicon_large@2x.png",
	iconSize: [30, 38],
	iconAnchor: [15, 38],
});
const MarkerIconSecondary = new L.Icon({
	iconUrl:
		"https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
	shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41],
});
const MarkerIconDefault = new L.Icon({
	iconUrl:
		"https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png",
	shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41],
});

const DotMarker = ({ type = "primary" }) =>
	new L.divIcon({
		className: "",
		html: `<div class='dot_marker dot_marker_${type}'></div>`,
		iconSize: [25, 25],
		iconAnchor: [12, 12],
	});

const PriceMarker = m =>
	new L.divIcon({
		className: "",
		html: `<div class='kJLafD gLfCZo'>${m.id}</div>`,
		iconSize: [30, 42],
		iconAnchor: [15, 42],
	});

const hospitalMarker = name => {
	// const classContainer = name ? "marker-container-full" : "marker-container";
	// <div class="marker-name">${name ?? ""}</div>;

	return new L.divIcon({
		className: "",
		html: `<div class='marker-container'>
					<div class='hospital_marker'>
						<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M6.76925 10.512H0.68925V7.056H6.76925V0.976H10.2253V7.056H16.3053V10.512H10.2253V16.592H6.76925V10.512Z" fill="#E84452"/>
						</svg>
					</div>
				</div>`,
		iconSize: [30, 40],
		iconAnchor: [20, 35],
	});
};

const schoolMarker = name => {
	// const classContainer = name ? "marker-container-full" : "marker-container";
	// <div class='marker-name'>${name ?? ""}</div>

	return new L.divIcon({
		className: "",
		html: `<div class='marker-container'>
					<div class='school_marker'>
						<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fillRule="evenodd" clip-rule="evenodd" d="M0 10.2556V13H2.74444L10.6889 4.98333L7.94444 2.23889L0 10.2556ZM12.7833 2.88889C13.0722 2.6 13.0722 2.16667 12.7833 1.87778L11.1222 0.216667C10.8333 -0.0722222 10.4 -0.0722222 10.1111 0.216667L8.81111 1.51667L11.5556 4.26111L12.7833 2.88889Z" fill="#44A3E8"/>
						</svg>
					</div>
				</div>`,
		iconSize: [30, 40],
		iconAnchor: [20, 35],
	});
};

export const LeafletMap = ({
	defaultZoom = 18,
	height = null,
	width = null,
	center,
	children = null,
	zIndex = 1,
	options = {},
	markers = [],
}) => {
	const [measure, setMeasure] = useState(null);


	return (
		<div style={{ zIndex: zIndex, width: "100%", height: "100%" }}>
			<Head>
				<link rel="stylesheet" href="https://unpkg.com/leaflet@1.5.1/dist/leaflet.css" />
			</Head>
			<Measure bounds onResize={m => m.entry && setMeasure(m)}>
				{({ measureRef }) => (
					<div ref={measureRef} style={{ width: "100%", height: "100%" }}>
						{measure && measure.entry && measure.entry.height && measure.entry.width && (
							<Map
								{...options}
								center={[center.latitude, center.longitude]}
								zoom={defaultZoom}
								minZoom={0}
								maxZoom={21}
								style={{
									height: height ? height : Math.round(measure.entry.height),
									width: width ? width : Math.round(measure.entry.width),
								}}>
								<TileLayer url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png" />
								<OverPassLayer marker={hospitalMarker} amenity="hospital" />
								<OverPassLayer marker={schoolMarker} amenity="school" />
								{markers.map((m, i) => {
									let icon = MarkerIconPrimary;
									if (m.icon && m.icon == "primary") {
										icon = DotMarker({ type: m.icon });
									} else if (m.icon && m.icon == "secondary") {
										icon = DotMarker({ type: m.icon });
									} else if (m.icon && m.icon == "large") {
										return (
											<Circle
												key={"leafletmarker_" + i}
												className={"marker-circle"}
												center={[m.latitude, m.longitude]}
												radius={75}
											/>
										);
									}

									//icon = PriceMarker(m);
									return (
										<Marker
											key={"leafletmarker_" + i}
											position={[m.latitude, m.longitude]}
											icon={icon}>
											{m.popup && <Popup>{m.popup.text}</Popup>}
										</Marker>
									);
								})}
							</Map>
						)}
					</div>
				)}
			</Measure>
		</div>
	);
};
